import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@webapp/assets/icons/laptop.svg'
import _imports_1 from '@webapp/assets/icons/tree_gray_150.png'
import _imports_2 from '@webapp/assets/icons/arrow_right.svg'
import _imports_3 from '@webapp/assets/icons/cloud.svg'
import _imports_4 from '@webapp/assets/tree-crossing-icon-128.png'


const _withScopeId = n => (_pushScopeId("data-v-4c86d924"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "computerRef",
  class: "computer"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tree"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "arrow"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cloud" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "logo"
  })
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncDiagram',
  props: {
    small: { type: Boolean },
    motion: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "rootRef",
    class: _normalizeClass(["sync-diagram", { 'small': props.small, motion: props.motion }])
  }, [
    _createElementVNode("div", _hoisted_1, _hoisted_4, 512),
    _hoisted_5,
    _hoisted_6
  ], 2))
}
}

})